import React from 'react';

import { Telemetry } from '~src/commonInfra/services/Telemetry';
import { TelemetryEvents, VPCFeatureUsageEvent } from '~src/commonInfra/telemetryEvents/TelemetryEvents';

// The usage extra parameters are defined for general purpose.
// It's a place for you to store extra information of the usage telemetry.
// "a" and "b" are for string data, "c" and "d" are for number data.
// For example, when we record the usage of card resizer slider, we use "a" for the space type and "c" for the slider value.
type UsageExtraParameters = {
    a?: string;
    b?: string;
    c?: number;
    d?: number;
};

export const debounceDuration = 300;

export function useUsage(featureName: string, extraParameters: UsageExtraParameters) {
    React.useEffect(() => {
        Telemetry.sendEvent<VPCFeatureUsageEvent>({
            type: TelemetryEvents.VPCFeatureUsage,
            feature_name: featureName,
            usage_type: 'impression',
            extra_parameter_a: extraParameters.a,
            extra_parameter_b: extraParameters.b,
            extra_parameter_c: extraParameters.c,
            extra_parameter_d: extraParameters.d,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const debounceTimerRef = React.useRef<NodeJS.Timer>(null);

    return (extraParameters: UsageExtraParameters, shouldDebounce?: boolean) => {
        const sendClickThroughTelemetryEvent = () => {
            Telemetry.sendEvent<VPCFeatureUsageEvent>({
                type: TelemetryEvents.VPCFeatureUsage,
                feature_name: featureName,
                usage_type: 'click_through',
                extra_parameter_a: extraParameters.a,
                extra_parameter_b: extraParameters.b,
                extra_parameter_c: extraParameters.c,
                extra_parameter_d: extraParameters.d,
            });
        };

        if (!shouldDebounce) {
            sendClickThroughTelemetryEvent();
        } else {
            clearTimeout(debounceTimerRef.current);
            debounceTimerRef.current = setTimeout(() => {
                sendClickThroughTelemetryEvent();
            }, debounceDuration);
        }
    };
}